import { Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { webDtos } from '@vectronic/openApi-customer';

@Component({
  selector: 'table-datatable-movebank-switch',
  templateUrl: './datatable-movebank-switch.component.html',
  styleUrls: ['./datatable-movebank-switch.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatSlideToggleModule],
})
export class DatatableMovebankSwitchComponent {
  toggleMovebankDevice = output<{ id: number; isInMovebank: boolean }>();
  syncCollarWithMovebank = output<{ id: number }>();

  movebankAccount = input<webDtos.MovebankAccount>();
  isCompactMode = input<boolean>(false);
  dataRow = input<any>();
  usernameExists = computed(() => Boolean(this.movebankAccount()?.movebankUsername));
  isActive = computed(
    () =>
      this.movebankAccount()?.deviceList?.find(({ idDevice }) => idDevice === this.dataRow()?.id)
        ?.forwardData,
  );
  isMovebankSyncEnabled = computed(() => {
    const id =
      this.dataRow() && 'id' in this.dataRow() ? this.dataRow().id : this.dataRow().idDevice;
    return this.movebankAccount()
      ?.deviceList?.filter(({ forwardData }) => forwardData)
      ?.map(({ idDevice }) => idDevice)
      ?.includes(id);
  });

  movebankToggle(event: MatSlideToggleChange, canToggle: boolean, id: number) {
    if (!canToggle) return;
    event.source.checked = this.isMovebankSyncEnabled();
    this.toggleMovebankDevice.emit({ id, isInMovebank: !event.checked });
  }

  onSyncCollarWithMovebank(canSync: boolean, id: number) {
    if (canSync) this.syncCollarWithMovebank.emit({ id });
  }
}
